import {
  Component,
  inject,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';

import { FeedAlgorithm } from 'src/app/core/models/algorithm.models';
import { FeedAlgorithmsService } from 'src/app/core/services/feed-algorithms.service';
import { PostAlgorithmService } from 'src/app/core/services/post-algorithm.service';

@Component({
  selector: 'app-feed-algorithms',
  templateUrl: './feed-algorithms.component.html',
  styleUrls: ['./feed-algorithms.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FeedAlgorithmsComponent implements OnInit {
  @Input() objectId!: string;
  @Input() objectClassId!: number;

  private readonly algorithmsService = inject(FeedAlgorithmsService);
  readonly attachedAlgorithms = this.algorithmsService.attached;
  readonly loading = this.algorithmsService.loading;
  readonly pendingAlgorithmIds = this.algorithmsService.pendingIds;

  constructor(private postAlgorithmService: PostAlgorithmService) {}

  ngOnInit(): void {
    // * The service's query observer is permanent, so mounting this panel does
    // * not fetch. This refetch is what shows an algorithm that was just
    // * scheduled from the Actions menu, the only way to attach one.
    this.algorithmsService.refresh();
  }

  isAlgorithmPending(id: number): boolean {
    return this.pendingAlgorithmIds().includes(id);
  }

  detachAlgorithm(algorithm: FeedAlgorithm): void {
    this.algorithmsService.detach(
      this.objectId,
      algorithm.id,
      algorithm.schedule_id,
    );
  }

  editAlgorithm(algorithm: FeedAlgorithm): void {
    this.postAlgorithmService.editFeedAlgorithmParams(this.objectId, algorithm);
  }

  hasEditableParams(algorithm: FeedAlgorithm): boolean {
    return !!algorithm.params && !Array.isArray(algorithm.params);
  }
}
